// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8242":"6efee1a42bf8f0c8","9253":"2d3cca4c9ed3c2dd"}[chunkId] + ".css";
};